import React from "react"
import strings from "../../../localization/strings"
import PayrollTimeByJobTable from "./PayrollTimeByJobTable"
import { CircularProgress } from "material-ui"
import { IPayrollTime } from "../../../models"
import _ from "lodash"

interface IProps {
    loading: boolean
    payrollData: IPayrollTime
    showTimecardPopup(employeeId: string, referenceDate: string): void
    reloadTimeCard: () => void
}

const PayrollTimeByJob: React.SFC<IProps> = (props: IProps) => {
    return (props.loading ?
        <div style={{ textAlign: "center", marginTop: 30 }}>
            <CircularProgress />
        </div> :
        <div style={{ textAlign: "center", marginTop: 20, overflow: "auto", paddingLeft: 5, paddingRight: 5 }}>
            {props.payrollData && props.payrollData.PayrollTimeJobs && props.payrollData.PayrollTimeJobs.length > 0 ?
                <PayrollTimeByJobTable
                    payrollDates={props.payrollData.PayrollDates}
                    payrollTimeJobs={props.payrollData.PayrollTimeJobs}
                    timeTotals={props.payrollData ? props.payrollData.HoursSummary.TimeTotals : null}
                    showTimecardPopup={props.showTimecardPopup}
                    reloadTimeCard={props.reloadTimeCard}
                /> :
                <div style={{ fontSize: 20, marginTop: 50, height: 22 }}>{strings.No_Payroll_Time_by_Hierarchy_Data}</div>
            }
        </div>
    )
}

export default PayrollTimeByJob
